import React from 'react';

interface ConfigErrorProps {
  missing: string[];
}

// Router-free, provider-free screen shown when required REACT_APP_* config
// is missing at startup. Mirrors CatastrophicErrorFallback (App.tsx) styling.
const ConfigError: React.FC<ConfigErrorProps> = ({ missing }) => (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: '2rem',
    background: '#F8F9FA',
    fontFamily: 'Roboto, sans-serif',
  }}>
    <div style={{
      background: 'white',
      borderRadius: '1rem',
      padding: '3rem',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
      maxWidth: '520px',
      textAlign: 'center',
    }}>
      <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>&#9888;</div>
      <h2 style={{ fontFamily: 'Montserrat, sans-serif', color: '#202124' }}>
        Configuration Error
      </h2>
      <p style={{ color: '#5F6368', marginBottom: '1.5rem' }}>
        This build of PropWise is missing required configuration and cannot
        start. The deployment must be rebuilt with a complete environment
        configuration.
      </p>
      {missing.length > 0 && (
        <div style={{
          textAlign: 'left',
          background: '#F8F9FA',
          borderRadius: '0.5rem',
          padding: '1rem',
          color: '#5F6368',
          fontFamily: 'monospace',
          fontSize: '0.875rem',
        }}>
          <div style={{ marginBottom: '0.5rem', fontWeight: 600 }}>
            Missing variables:
          </div>
          <ul style={{ margin: 0, paddingLeft: '1.25rem' }}>
            {missing.map((name) => (
              <li key={name}>{name}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  </div>
);

export default ConfigError;
